export const digitSeparator = (digit: string) => {
  digit = digit.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(digit)) digit = digit.replace(pattern, "$1,$2");
  return digit;
};
